import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doCreateSubZone = createAsyncThunk(
  "subZones/doCreateSubZone",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doCreateSubZone(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);


export const doUpdateSubZone = createAsyncThunk(
  "subZones/doUpdateSubZone",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doUpdateSubZone(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doDetailSubZone = createAsyncThunk(
  "subZones/doDetailSubZone",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doDetailSubZone(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);

export const doDeleteSubZone = createAsyncThunk(
  "subZones/doDeleteSubZone",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doDeleteSubZone(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  }
);
